/**
 * Rocnovel 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Rocnovel 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/rocnovel/home-bg.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#9875FB',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#F4F1FF',
  tagInactiveText: '#9875FB',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #9875FB 95%)',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
